<template>
  <b-card>
    <ConfirmModal
      ref="confirmModal"
      variant="danger"
      :title="confirmModal.title"
      :description="confirmModal.description"
    />
    <b-tabs
      v-model="currentTab"
      justified
      pills>
      <!-- Render Tabs, supply a unique `key` to each tab -->
      <b-tab
        v-for="(ticket, index) in tickets"
        :key="'dyn-tab-' + index"
        title-link-class="rounded-tab"
        :title="'Ticket' + index">
        <template #title>
          <div
            class="d-flex align-items-center justify-content-between"
            style="height: 30px">
            <span class="d-inline-block"></span>
            <span
              v-if="ticket && ticket.code"
              class="d-inline-block"
              style="color: black;">{{ ticket.code }}
            </span>
            <span
              v-else
              class="d-inline-block">
              Ticket
            </span>
            <span
              class="d-inline-block"
              @click="closeTab(index)">
              <b style="font-size: 20px;">X</b>
            </span>
          </div>
        </template>
        <TicketTab
          v-if="isLoaded"
          :tab-index="index"
          :item="ticket"
          :all-ref="allRef"
          @switch-tab="changeCurrentTab($event)"
        />
      </b-tab>

      <!-- New Tab Button (Using tabs-end slot) -->
      <template
        v-if="tickets.length < 5"
        #tabs-end>
        <b-nav-item
          role="presentation"
          @click.prevent="newTab">
          <b style="font-size: 26px;">+</b>
        </b-nav-item>
      </template>

      <!-- Render this if no tabs -->
      <template>
        <div class="text-center text-muted">
        </div>
      </template>
    </b-tabs>

    <template>
    </template>
  </b-card>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import TicketProvider from '@/resources/TicketProvider'
import ConfirmModal from '@/components/ConfirmModal.vue'
import returnDataTicket from '@/utils/data-ticket'

import TicketTab from './TicketTab.vue'
import { loadTicketRefs } from '@/utils/ticket-ref-cache'
import { loadCustomerRefs } from '@/utils/customer-ref-cache'

const TicketService = new TicketProvider()

export default {
  components: {
    TicketTab,
    ConfirmModal
  },
  data () {
    return {
      isLoaded: false,
      currentTab: 0,
      tabs: [1],
      tabCounter: 1,
      confirmModal: {
        title: 'Are you sure ?',
        description: 'You want to close tabs ?'
      },
      allRef: {
        ticketType: [],
        contactChannel: [],
        callCategory: [],
        categories: [],
        plant: [],
        customerType: [],
        customerGroup: [],
        companyGroup: [],
        companyDepartment: [],
        companyCenter: []
      }
    }
  },
  computed: {
    // mix the getters into computed with object spread operator
    ...mapGetters({
      tickets: 'ticket/tickets',
      profile: 'User/user'
    })
  },
  watch: {
    tickets (newTicket) {
      if (newTicket) {
        const ticketLength = newTicket?.length - 1
        setTimeout(() => {
          this.changeCurrentTab(ticketLength)
        }, 100)
      }
    }
  },
  async mounted () {
    try {
      const { tickets } = this
      if (Array.isArray(tickets) && tickets.length > 0) {
        const ticketLength = tickets.length - 1
        setTimeout(() => {
          this.changeCurrentTab(ticketLength)
        }, 300)
      }
      await Promise.all([
        this.getAllOptions(),
        this.getAllRefCustomer()
      ])
    } catch (error) {
      console.error(error)
    } finally {
      this.isLoaded = true
    }
  },
  methods: {
    ...mapActions({
      addTicket: 'ticket/ADD_TICKET',
      deleteTicket: 'ticket/DELETE_TICKET'
    }),
    async closeTab (x) {
      try {
        const confirm = await this.$refs.confirmModal.show({ description: 'You want to close tab ?' })
        if (confirm) {
          this.$store.dispatch('activity/increaseLoading')
          this.isLoaded = false
          this.deleteTicket(x)
          setTimeout(() => {
            this.isLoaded = true
          }, 100)
        }
      } catch (error) {
        console.error(error)
      } finally {
        this.$store.dispatch('activity/decreaseLoading')
      }
    },
    async newTab () {
      try {
        this.$store.dispatch('activity/increaseLoading')
        const { data } = await TicketService.createInitial(this.profile.id)
        const payload = returnDataTicket(data)
        const addTicket = await this.addTicket(payload)
        if (Array.isArray(addTicket) && addTicket.length > 0) {
          const numIndex = addTicket.length - 1
          setTimeout(() => {
            this.changeCurrentTab(numIndex)
          }, 300)
        }
      } catch (error) {
        console.error(error)
      } finally {
        this.$store.dispatch('activity/decreaseLoading')
      }
    },
    async getAllOptions () {
      try {
        this.isShowComponent = false
        const refs = await loadTicketRefs()
        this.allRef.categories = refs.categories
        this.allRef.ticketType = refs.ticketType
        this.allRef.contactChannel = refs.contactChannel
        this.allRef.plant = refs.plant
      } catch (error) {
        console.error(error)
      } finally {
        this.isShowComponent = true
      }
    },
    async getAllRefCustomer () {
      try {
        const refs = await loadCustomerRefs()
        this.allRef.customerType = refs.customerType
        this.allRef.customerGroup = refs.customerGroup
        this.allRef.companyGroup = refs.companyGroup
        this.allRef.companyDepartment = refs.companyDepartment
        this.allRef.companyCenter = refs.companyCenter
      } catch (error) {
        console.error(error)
      }
    },
    changeCurrentTab (index) {
      this.currentTab = index
    }
  }
}
</script>

<style lang="scss" scoped>
</style>
